<div class="email-distribution-container">
  <h2>Email Configuration</h2>
 
  <p class="configuration-description">
    <a [routerLink]="['/admin/notification-configuration/email-events']"
      >Email Events - Roles - User IDs (ERC)</a
    >
    | Review email events; add or remove email roles from email events; add or
    remove User IDs from email roles
  </p>

  <np-tabbed (click)="setFlag()">
    <ul class="tabs">
      <li role="tab" aria-selected="true">User ID- Roles List</li>
      <li role="tab" aria-selected="false">Add New User</li>
    </ul>

    <div class="tab-content" role="tabpanel" aria-hidden="false">
      <div class="search-container">
        <div class="search-field">
          <label for="userId">User ID:</label>
          <span class="p-input-icon-right">
            <i class="pi pi-search"></i>
            <input
              pInputText
              id="userId"
              type="text"
              [(ngModel)]="searchUserId"
              (ngModelChange)="onSearchInputChange()"
              (keydown.enter)="searchUser()"
              placeholder="Enter user ID"
            />
          </span>
          <button
            pButton
            label="Search User ID"
            (click)="searchUser()"
            class="btn-primary h-30"
          ></button>
        </div>
        <p class="red" *ngIf="deleteSucess">The item has been successfully deleted.</p>
        <div
          *ngIf="showUserDetails && selectedUser"
          class="user-verification-results"
        >
          <div class="user-info">
            <div class="info-row">
              <span>Email:</span>
              <span>{{ selectedUser.emailAddress || "N/A" }}</span>
            </div>
            <div class="info-row">
              <span>Full Name:</span>
              <span>{{ selectedUser.name || "N/A" }}</span>
            </div>
          </div>

          <div class="roles-selection">
            <div class="roles-label">Roles:</div>
            <div class="role-checkboxes">
              <div class="role-item">
                <p-checkbox
                  [(ngModel)]="selectedUser.airGroup"
                  [binary]="true"
                  id="admin"
                ></p-checkbox>
                <label for="admin">Air Group</label>
              </div>
              <div class="role-item">
                <p-checkbox
                  [(ngModel)]="selectedUser.operatingAssistant"
                  [binary]="true"
                  id="inspections"
                ></p-checkbox>
                <label for="inspections">Operating Assistant</label>
              </div>
              <div class="role-item">
                <p-checkbox
                  [(ngModel)]="selectedUser.maintainace"
                  [binary]="true"
                  id="oa"
                ></p-checkbox>
                <label for="oa">Maintainence</label>
              </div>
              <div class="role-item">
                <p-checkbox
                  [(ngModel)]="selectedUser.inspector"
                  [binary]="true"
                  id="airCompliance"
                ></p-checkbox>
                <label for="airCompliance">Inspector</label>
              </div>
              <div class="role-item">
                <p-checkbox
                  [(ngModel)]="selectedUser.engineer"
                  [binary]="true"
                  id="leadEngineer"
                ></p-checkbox>
                <label for="leadEngineer">Engineer</label>
              </div>
              <div class="role-item">
                <p-checkbox
                  [(ngModel)]="selectedUser.refineryShiftLeader"
                  [binary]="true"
                  id="engineering"
                ></p-checkbox>
                <label for="engineering">Refinery Shift Leader</label>
              </div>
            </div>
          </div>

          <div class="save-changes">
            <button pButton (click)="saveChanges()" class="btn-primary">
              Save Changes
            </button>
          </div>
        </div>
      </div>

      <p-table
        *ngIf="!showUserDetails"
        [value]="filteredUsers"
        id="StyleTable"
        styleClass="p-datatable-gridlines"
        scrollHeight="600px"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>User ID</th>
            <th>Name</th>
            <th>Email</th>
            <th class="align-center">Air Group</th>
            <th class="align-center">Operating Assistant</th>
            <th class="align-center">Maintenance</th>
            <th class="align-center">Inspector</th>
            <th class="align-center">Engineer</th>
            <th class="align-center">Refinery Shift Leader</th>
            <th class="align-center">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
          <tr>
            <td>{{ user.userId }}</td>
            <td>{{ user.name }}</td>
            <td>{{ user.emailAddress }}</td>
            <td class="checkbox-cell align-center">
              <p-checkbox
                [(ngModel)]="user.airGroup"
                [binary]="true"
              ></p-checkbox>
            </td>
            <td class="checkbox-cell align-center">
              <p-checkbox
                [(ngModel)]="user.operatingAssistant"
                [binary]="true"
              ></p-checkbox>
            </td>
            <td class="checkbox-cell align-center">
              <p-checkbox
                [(ngModel)]="user.maintainace"
                [binary]="true"
              ></p-checkbox>
            </td>
            <td class="checkbox-cell align-center">
              <p-checkbox
                [(ngModel)]="user.inspector"
                [binary]="true"
              ></p-checkbox>
            </td>
            <td class="checkbox-cell align-center">
              <p-checkbox
                [(ngModel)]="user.engineer"
                [binary]="true"
              ></p-checkbox>
            </td>
            <td class="checkbox-cell align-center">
              <p-checkbox
                [(ngModel)]="user.refineryShiftLeader"
                [binary]="true"
              ></p-checkbox>
            </td>            <td>
              <div class="button-wrapper d-flex gap-2">
                <button
                  pButton
                  label="Update"
                  (click)="updateUser(user)"
                  class="btn-primary h-30"
                  severity="info"
                ></button>
                <button
                  pButton
                  label="Delete User"
                  (click)="deleteUser(user.recID, user.emailAddress)"
                  class="cancel-btn h-30"
                  severity="danger"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr *ngIf="noResultsFound">
            <td colspan="10" class="empty-message">
              No users found matching "{{ prevSearchUserId }}". Please try another
              search.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="tab-content" role="tabpanel" aria-hidden="true">
      <div class="add-user-form">
        <span class="tabheading">User ID Verification</span>

        <div class="user-id-verification">
          <div class="form-row">
            <label for="newUserId">User ID:</label>
            <input
              pInputText
              id="newUserId"
              type="text"
              [(ngModel)]="newUserId"
              class="user-id-input"
              (keydown.enter)="verifyUserId()"
            />
            <div class="verification-buttons">
              <button pButton class="btn-primary"  (click)="verifyUserId()">
                Verify User ID, View Roles
              </button>
              <button pButton class="cancel-btn" (click)="clearUserId()">
                Clear User ID
              </button>
            </div>
          </div>

          <!-- Display message when user doesnt exists -->
          <p *ngIf="userExists" class="verification-message">
            User ID already Exists
          </p>

          <!-- Display user information when verified -->
          <div *ngIf="userVerified && !userExists" class="user-info-display">
            <p class="user-email">
              <span>Email: </span>{{ newUserRoles.emailAddress }}
            </p>
            <p class="user-name">
              <span>Full Name: </span>{{ newUserRoles.name }}
            </p>
            <p class="user-phone">
              <span>Phone: </span>{{ newUserRoles.phone || "" }}
            </p>
          </div>
        </div>

        <!-- Only show role selection for  users -->
        <div *ngIf="userVerified && !userExists" class="user-roles-section">
          <p class="verification-message">
            User ID verified. Please select roles for this user:
          </p>

          <div class="roles-horizontal-container">
            <div class="role-item">
              <label>Air Group:</label>
              <p-checkbox
                [(ngModel)]="newUserRoles.airGroup"
                [binary]="true"
              ></p-checkbox>
            </div>

            <div class="role-item">
              <label>Engineer:</label>
              <p-checkbox
                [(ngModel)]="newUserRoles.engineer"
                [binary]="true"
              ></p-checkbox>
            </div>

            <div class="role-item">
              <label>Inspector:</label>
              <p-checkbox
                [(ngModel)]="newUserRoles.inspector"
                [binary]="true"
              ></p-checkbox>
            </div>

            <div class="role-item">
              <label>Maintenance:</label>
              <p-checkbox
                [(ngModel)]="newUserRoles.maintainace"
                [binary]="true"
              ></p-checkbox>
            </div>

            <div class="role-item">
              <label>Operating Assistant:</label>
              <p-checkbox
                [(ngModel)]="newUserRoles.operatingAssistant"
                [binary]="true"
              ></p-checkbox>
            </div>

            <div class="role-item">
              <label>Refinery Shift Leader:</label>
              <p-checkbox
                [(ngModel)]="newUserRoles.refineryShiftLeader"
                [binary]="true"
              ></p-checkbox>
            </div>
          </div>

          <div class="add-user-action">
             <button pButton label="Save Changes" class="btn-primary h-20" (click)="addUser()"></button>
          </div>
        </div>
      </div>
    </div>
  </np-tabbed>
</div>
